/**
 * @author Sarthak Sharma.
 * @since 02-01-2024.
 * @type {string} Artist action types.
 */

export const SET_LOADING = '[ACTOR] SET_LOADING';
export const SET_ARTIST_LIST = '[ACTOR] SET_ARTIST_LIST';
export const SET_ARTIST_LIST_META = '[ACTOR] SET_ARTIST_LIST_META';
export const SET_ARTIST = '[ACTOR] SET_ARTIST';
export const SET_ARTIST_AUDITION = '[ACTOR] SET_ARTIST_AUDITION';
export const SET_ARTIST_IMAGES = '[ACTOR] SET_ARTIST_IMAGES';
export const SET_ARTIST_VIDEOS = '[ACTOR] SET_ARTIST_VIDEOS';
export const SET_ARTIST_AUDIOS = '[ACTOR] SET_ARTIST_AUDIOS';

